module.exports = __webpack_public_path__ + "static/media/uitnodiging.9bc77c69.jpg";